export class AppSettings {
    public static get maxCharacterLimit(): number {
        return 180;
    }

    public static get ckeditorConfig(): any {
        return {
            toolbar: {
                items: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    '|',
                    'link',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'outdent',
                    'indent',
                    '|',
                    'blockQuote',
                    '|',
                    'undo',
                    'redo'
                ],
                shouldNotGroupWhenFull: true
            },
            fontSize: {
                options: [
                    8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26, 28, 32, 36, 48, 72
                ],
                supportAllValues: true
            },
            fontFamily: {
                options: [
                    'default',
                    'Arial, Helvetica, sans-serif',
                    'Courier New, Courier, monospace',
                    'Georgia, serif',
                    'Lucida Sans Unicode, Lucida Grande, sans-serif',
                    'Tahoma, Geneva, sans-serif',
                    'Times New Roman, Times, serif',
                    'Trebuchet MS, Helvetica, sans-serif',
                    'Verdana, Geneva, sans-serif'
                ],
                supportAllValues: true
            },
            fontColor: {
                columns: 5,
                documentColors: 10
            },
            fontBackgroundColor: {
                columns: 5,
                documentColors: 10
            },
            heading: {
                options: [
                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
                ]
            },
            link: {
                decorators: {
                    openInNewTab: {
                        mode: 'manual',
                        label: 'Open in a new tab',
                        attributes: {
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        }
                    }
                }
            },
            // Enhanced clipboard functionality
            clipboard: {
                // Enable paste from Word with proper formatting cleanup
                pasteFromWord: {
                    // Clean up Word-specific formatting
                    cleanupWordFormats: true,
                    removeWordFormatting: true
                }
            },
            // Enhanced features for better user experience
            typing: {
                transformations: {
                    extra: [
                        { from: '--', to: '–' },
                        { from: '---', to: '—' },
                        { from: '(c)', to: '©' },
                        { from: '(r)', to: '®' },
                        { from: '(tm)', to: '™' }
                    ]
                }
            },
            placeholder: 'Start typing here...',
            // Better performance and UX
            balloonToolbar: ['bold', 'italic', 'link', 'cut', 'copy', 'paste'],
            // Keyboard shortcuts for clipboard operations
            keystrokes: [
                ['Ctrl+C', 'copy'],
                ['Ctrl+X', 'cut'],
                ['Ctrl+V', 'paste'],
                ['Ctrl+Shift+V', 'pasteAsPlainText']
            ],
            // Set minimum height for editor content area
            minHeight: '300px',
            // Suppress all CKEditor branding including focus state
            licenseKey: '',
            // Remove "Powered by CKEditor" branding
            ui: {
                poweredBy: {
                    forceVisible: false,
                    label: null,
                    side: 'right'
                }
            }
        };
    }

    public static get emailRegExp(): RegExp {
        return RegExp(/(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/);
    }

    public static get urlRegExp(): RegExp {
        return RegExp(/((^http(s)?)((:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\/\-\+=&;~:<>,'?%@$^*(){​}​[\]\.\w_#]*)(?:[\.\!\/\\\w]*))?)?/);
    }

    public static get alphaNumeric(): RegExp {
        return RegExp(/^[0-9a-zA-Z \-,\.\(\)\%\"\&]+$/m);
    }

    public static get pendingChangeText(): string {
        return "You haven\'t save your changes , do you still wish to leave this page?  Any unsaved changes will be lost.";
    }
}